import { OPENSEARCH_ONLY_MAX_LOOKBACK_DAYS } from 'ducks/reports/constants'
import { isDefined } from 'util/nullOrUndefinedChecks'

export const REPORTING_PERIODS = [
  { label: 'Last 7 days', value: 'previous_7_days' },
  { label: 'Last 30 days', value: 'previous_30_days' },
]

export function shouldShowReportingPeriodDropdown(
  minStartDate,
  maxReportingDays
) {
  if (!minStartDate) return false
  if (!isDefined(maxReportingDays)) return true
  const days = Number(maxReportingDays)
  const isBillingLimitTighter =
    !isNaN(days) && days - 1 < OPENSEARCH_ONLY_MAX_LOOKBACK_DAYS
  return !isBillingLimitTighter
}

export function shouldResetReportingPeriod(
  rawTimeframe,
  startDate,
  earliestStartDate
) {
  const isSupportedPreset = REPORTING_PERIODS.some(
    period => rawTimeframe === period.value
  )
  return (
    !isSupportedPreset || (!!earliestStartDate && startDate < earliestStartDate)
  )
}
